import { useCallback, useMemo } from 'react';

import { CommonService, DataStorageQuery } from 'dashboard-services';

import properties from 'resources/constants/properties.json';

import { useInfiniteQuery, useQueries } from '@tanstack/react-query';

export default (() => {

  const useSearchSymbols = ({ query, access, collapse, symbolValuesExactMatch, withValuesOnly, getQueryBuilder, sortBy, shouldBeLimited, size = CommonService.getRequestSize(), shouldRefetch = true, provider, ...rest }) => (
    useInfiniteQuery({
      ...DataStorageQuery.QUERIES.searchSymbols(
        getQueryBuilder,
        {
          size,
          sortBy,
          collapse,
          query,
          symbolValuesExactMatch,
          withValuesOnly,
          provider,
          access
        }
      ),
      initialPageParam: 0,
      refetchInterval: () => !shouldRefetch || shouldBeLimited() ? undefined : 10000,
      getNextPageParam: lastPage => lastPage.totalSize > lastPage.from + (lastPage.items || []).length ? lastPage.from + (lastPage.items || []).length : undefined,
      ...rest
    })
  )

  const useSearchSymbolKeys = ({ getQueryBuilder, groupName, query, symbols, size, sort, metadata, metadatas, useEs, omitRequiredKeys, enabled = true, provider, ...rest }) =>
    useInfiniteQuery({
      ...DataStorageQuery.QUERIES.getSymbolKeys(
        getQueryBuilder,
        {
          groupName,
          query, 
          symbols,
          size,
          sort,
          metadata,
          metadatas,
          useEs,
          omitRequiredKeys,
          provider
        }
      ),
      initialPageParam: 0,
      getNextPageParam: lastPage => lastPage.totalSize > lastPage.from + (lastPage.items || []).length ? lastPage.from + (lastPage.items || []).length : undefined,
      enabled,
      ...rest
    })

    const useGetColumns = ({ selectedSymbols, getQueryBuilder, provider }) => {
      const queries = useMemo(() => 
        selectedSymbols.map((symbol, symbolIndex) => {
          if(symbol.pattern === undefined || symbol.pattern === true || !symbol.values) {
            return {
              ...DataStorageQuery.QUERIES.getSymbolColumns(getQueryBuilder, {
                groupName: symbol.groupName,
                query: undefined,
                symbols: symbol.symbols,
                metadatas: symbol.metadata,
                size: 50,
                metadata: true,
                useEs: properties.useEsSymbolListing === "true",
                symbolIndex,
                provider
              }),
              select: response => (response?.items || []).map(item => item?.name)
            }
          } else {
            return {
              queryKey: [CommonService.generateUID(), symbolIndex],
              queryFn: async () => Promise.resolve(symbol.values)
            }
          }
        })
      , [selectedSymbols, getQueryBuilder, provider]),
      combine = useCallback(results => ({
        data: results.map(result => result?.data).flat().toUnique().filter(v => !!v).sort((a, b) => a.localeCompare(b)).map(v => ({ label: v, value: v })),
        isPending: results.some(result => result.isPending)
      }), [])

      return useQueries({
        queries,
        combine
      })
    }

  return { 
    useSearchSymbols,
    useSearchSymbolKeys,
    useGetColumns
  }
})()